<template>
  <modal
    :headline="$t('productSheets.historyModal.headline')"
    class="ce-documentVersionHistory"
    @close="$emit('close')">
    <div class="ce-modalContent">
      <alert
        v-if="hasMessage"
        :message="message.content"
        :type="message.type"
        :closable="false" />

      <div v-if="loading">
        <fa-icon
          icon="spinner"
          spin />
      </div>
      <div v-else>
        <div v-if="hasHistory">
          <document-version-history-item
            v-for="item in history"
            :key="item.id"
            :item="item" />
        </div>
        <div v-else>
          {{ $t('documentVersionHistory.noHistory') }}
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import DocumentVersionHistoryItem from './DocumentVersionHistoryItem.vue';

export default {
  props: {
    asset: {
      type: Object,
      required: true
    },
    product: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      history: null,
      message: {
        type: 'success',
        content: null
      },
    };
  },
  components: { DocumentVersionHistoryItem },
  created() {
    this.fetchHistory();
  },
  computed: {
    ...mapGetters(['documentServiceClient']),
    hasMessage() {
      return this.message && this.message.content;
    },
    hasHistory() {
      return this.history && Array.isArray(this.history) && this.history.length > 0;
    }
  },
  methods: {
    async fetchHistory() {
      try {
        const response = await this.documentServiceClient.get(`/history/${this.asset.id}?prd=${this.product.prd}`);

        this.history = response.data;
        this.loading = false;
      } catch (e) {
        this.message = {
          type: 'error',
          content: `Failed with message ${e.message}`
        };
      }
    }
  }
};
</script>
